import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { domToReact } from 'html-react-parser';
import { closeMobileMenus } from './pageEffects';
import { ContentNavigation } from '../components/content/ContentNavigation';

const anonymousNodeKeys = new WeakMap();
let nextNodeKey = 0;

function nodeKey(node) {
  const semanticKey = node.attribs?.['data-testid'] || node.attribs?.id;
  if (semanticKey) return semanticKey;
  // Text/comment nodes have no attributes; their DOM identity stays stable for this tree.
  if (!anonymousNodeKeys.has(node)) anonymousNodeKeys.set(node, `source-node-${++nextNodeKey}`);
  return anonymousNodeKeys.get(node);
}

export function renderNavigation({ node, props, options, sourcePath }) {
  const mobile = node.attribs['aria-label'] === 'Menu';
  const insertAt = mobile ? 3 : node.children.findIndex(child => child.name === 'a' && child.attribs?.href?.startsWith('#'));
  const intakeLink = <Link key="intake-link" to="/intake" onClick={closeMobileMenus} aria-current={sourcePath === '/intake' ? 'page' : undefined} className={mobile ? 'px-4 py-3 text-sm text-white/85 hover:bg-teal hover:text-white' : 'text-[12px] font-medium text-white/80 hover:text-white'} data-testid={mobile ? 'mobile-intake-link' : 'desktop-intake-link'}>Intake Form</Link>;
  const children = node.children.map(child => <Fragment key={nodeKey(child)}>{domToReact([child], options)}</Fragment>);
  children.splice(insertAt < 0 ? children.length : insertAt, 0, intakeLink);
  children.splice(insertAt < 0 ? children.length - 1 : insertAt, 0, <ContentNavigation key="content-navigation" mobile={mobile} />);
  return <nav {...props} {...(mobile ? { id: 'site-mobile-menu' } : {})}>{children}</nav>;
}

export function renderFooterLinks({ node, props, options }) {
  return <div {...props}>{domToReact(node.children, options)}<Link to="/intake" className="text-[13px] text-white/70 hover:text-white" data-testid="footer-intake-link">Intake Form</Link><ContentNavigation footer /></div>;
}

export function renderInternalLink({ node, props, options, standalone }) {
  const { href, ...rest } = props;
  const to = standalone && href.startsWith('#') ? '/#contact' : href;
  return <Link {...rest} to={to} onClick={closeMobileMenus}>{domToReact(node.children, options)}</Link>;
}